(function () {
  "use strict";

  function initCarousel(section) {
    var container = section.querySelector(".reviews-carousel-swiper");
    if (!container || container.swiper) return;

    var swiperLoad =
      typeof window.swiperCheckAndLoad === "function"
        ? window.swiperCheckAndLoad()
        : Promise.resolve();

    swiperLoad.then(function () {
      if (!container || container.swiper) return;
      if (typeof window.Swiper === "undefined") return;

      container.classList.remove("reviews-carousel-swiper--pending");

      // Configuracion calcada de Smooche (smooche.com, seccion kopstorm_testimonials):
      // slidesPerView 1.3 / 2.5 / 4 con spaceBetween 13 / 16 / 20.
      // Sin flechas: se navega arrastrando.
      var swiperConfig = {
        slidesPerView: 1.3,
        spaceBetween: 13,
        loop: false,
        speed: 400,
        breakpoints: {
          // centerInsufficientSlides: si hay menos tarjetas que lugares,
          // el grupo queda centrado en vez de pegado a la izquierda.
          767: { slidesPerView: 2.5, spaceBetween: 16, centerInsufficientSlides: true },
          1000: { slidesPerView: 4, spaceBetween: 20, centerInsufficientSlides: true }
        },
        grabCursor: true,
        observer: true,
        observeParents: true
      };

      var swiper = new window.Swiper(container, swiperConfig);

      // SMUD: flechas de desktop. Se ocultan solas en los extremos, así que
      // cuando entran todas las reseñas no aparece ninguna.
      var prev = section.querySelector(".reviews-nav-arrow--prev");
      var next = section.querySelector(".reviews-nav-arrow--next");

      if (prev && next) {
        var refrescar = function () {
          prev.hidden = swiper.isBeginning;
          next.hidden = swiper.isEnd;
        };

        prev.addEventListener("click", function () { swiper.slidePrev(); });
        next.addEventListener("click", function () { swiper.slideNext(); });

        swiper.on("slideChange", refrescar);
        swiper.on("reachBeginning", refrescar);
        swiper.on("reachEnd", refrescar);
        swiper.on("resize", refrescar);
        swiper.on("observerUpdate", refrescar);
        refrescar();
      }
    });
  }

  function runInit() {
    var sections = document.querySelectorAll(".reviews-transformation-section");
    sections.forEach(function (section) {
      if (section.querySelector(".reviews-carousel-swiper")) {
        initCarousel(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector && e.target.querySelector(".reviews-transformation-section");
    if (section) {
      initCarousel(section);
    } else if (e.target.classList && e.target.classList.contains("reviews-transformation-section")) {
      initCarousel(e.target);
    }
  });
})();